import QROnlyPage from './QROnlyPage';

export default QROnlyPage;
